import React from "react";

import ACIconWrapper, { ACIconProps } from "./ACIconWrapper";

export default function ItalicIcon(props: ACIconProps) {
  return <ACIconWrapper component={IconSvg} {...props} />;
}

const IconSvg = () => {
  return (
    <svg height="1em" viewBox="0 0 24 24" fill="none">
      <path
        xmlns="http://www.w3.org/2000/svg"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11 4.75C11 4.33579 11.3358 4 11.75 4H16.25C16.6642 4 17 4.33579 17 4.75C17 5.16421 16.6642 5.5 16.25 5.5H14.5711L10.9849 18.5H12.25C12.6642 18.5 13 18.8358 13 19.25C13 19.6642 12.6642 20 12.25 20H7.75C7.33579 20 7 19.6642 7 19.25C7 18.8358 7.33579 18.5 7.75 18.5H9.42888L13.0151 5.5H11.75C11.3358 5.5 11 5.16421 11 4.75Z"
        fill="currentColor"
      />
    </svg>
  );
};
